import { render, staticRenderFns } from "./OrderViewAdditionalCancelledNotApply.vue?vue&type=template&id=60ab7f7a&"
import script from "./OrderViewAdditionalCancelledNotApply.vue?vue&type=script&lang=js&"
export * from "./OrderViewAdditionalCancelledNotApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports